import { config } from '@uhg-abyss/web/tools/config';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Flex } from '@uhg-abyss/web/ui/Flex';

export const Filters = styled('div', {
  marginTop: '$md',
  marginBottom: '28px',
});

export const filterLabelStyle = {
  '&.abyss-text-root': {
    fontWeight: '600',
    fontSize: '$smallText',
    lineHeight: '$sm',
  },
};

export const Filterlabel = styled('div', {
  marginBottom: '-4px',
});
export const FilterContainer = styled('div', {});

export const FiltersFlexStyled = styled(Flex, {
  dynamic: ({ cssProps: { expandedProviderListView, choosePCP } = {} }) => ({
    marginTop: !expandedProviderListView && '$md !important',
    marginBottom: !expandedProviderListView && '28px !important',
    '&.abyss-flex-root': {
      margin: !expandedProviderListView && '0 0 $md 0',
      justifyContent:
        expandedProviderListView && choosePCP ? 'normal' : 'space-between',
      flexWrap: expandedProviderListView && choosePCP ? 'wrap' : 'nowrap',
    },
  }),
});

export const ButtonStyled = styled(Button, {
  '&.abyss-button-root': {
    zIndex: '1',
    border: '1px solid $core.color.brand.100',
    fontWeight: '600',
    '@media (max-width: 1248px)': {
      marginRight: '0px',
    },
    '.abyss-icon-symbol': {
      color: '$core.color.brand.100',
    },
  },
});

export const TextStyles = {
  color: '$core.color.brand.100',
  fontWeight: 700,
  fontSize: '16px',
  lineHeight: '20px',
};

export const mapImage = `${config('CDN_BASE_URL')}/cdn/assets/map.png`;

export const FiltersContainer = styled('div', {
  dynamic: ({ cssProps: { expandedProviderListView, choosePCP } = {} }) => ({
    marginTop: expandedProviderListView ? (choosePCP ? '$md' : '0px') : '$md',
    marginBottom: expandedProviderListView
      ? choosePCP
        ? '28px'
        : '0px'
      : '28px',
  }),
});

export const MapViewListViewToggleContainer = styled(Flex, {
  dynamic: ({ cssProps: { expandedProviderListView } = {} }) => ({
    '&.abyss-flex-root': {
      display: 'flex',
      alignItems: 'center',
      border: expandedProviderListView ? '1px solid #CBCCCD' : 'none',
      borderRadius: expandedProviderListView ? '5px' : '0px',
      backgroundImage: expandedProviderListView
        ? `url(${mapImage}) !important`
        : 'none',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'right center',
      width: '281px',
      height: '71px',
      marginRight: expandedProviderListView
        ? 'calc((100vw - 1248px)/2)'
        : '0px',
      '@media (max-width: 1248px)': {
        marginRight: '20px',
      },
      '@media (max-width: 744px)': {
        marginRight: '16px',
      },
      '@media (max-width: 464px)': {
        padding: '0',
        margin: '0',
      },
    },
  }),
});
